import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../service/http.service';
import { ToastMessageService } from '../toast-message.service';
import { PdfDocumentTemplateService } from '../pdf-document-template.service';
import { PdfTemplateViewOption } from '../pdf-template-view-option.enum';

@Component({
  selector: 'app-edit-wp-contact-request-pdf-template',
  templateUrl: './edit-wp-contact-request-pdf-template.component.html',
  styleUrls: ['./edit-wp-contact-request-pdf-template.component.css']
})
export class EditWpContactRequestPdfTemplateComponent implements OnInit {

  templateForm!: FormGroup;

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    private toastService: ToastMessageService,
    public pdfDocumentService: PdfDocumentTemplateService,
    private pdfDocumentTemplateservice: PdfDocumentTemplateService
  ) { }

  ngOnInit(): void {
    let template = this.pdfDocumentService.selectedContactRequestPdfTemplate;
    this.pdfDocumentTemplateservice.selectedLanguage = template.language;
    this.templateForm = this.builder.group({
      name: [template.name, Validators.required],
      body: [template.body, Validators.required]
    });
  }

  backToTemplateList(){
    this.pdfDocumentTemplateservice.activeItemId = PdfTemplateViewOption.CONTACT_REQUEST_RELATED;
  }

  sendForm() {
    if (this.templateForm.invalid) {
      this.toastService.addError("Error", "Please complete all informations");
      return;
    }
    this.pdfDocumentService.selectedContactRequestPdfTemplate.name = this.templateForm.value.name.trim();
    this.pdfDocumentService.selectedContactRequestPdfTemplate.body = this.templateForm.value.body.trim();
    this.pdfDocumentService.selectedContactRequestPdfTemplate.language = this.pdfDocumentTemplateservice.selectedLanguage;

    this.httpService.updateContactRequestPdfTemplate(this.pdfDocumentService.selectedContactRequestPdfTemplate).subscribe(() => {
      this.toastService.addSuccess("Success", "Template updated");
    }, error => this.toastService.addError("Error", error.message));
  }

}
